var map = {
	"./dreams/AI.png": "90be",
	"./dreams/AI人脸.png": "3131",
	"./dreams/diqui.gif": "cdd7",
	"./dreams/gift11.png": "8076",
	"./dreams/hx.gif": "2a0a",
	"./dreams/不.gif": "76df",
	"./dreams/动漫樱花.png": "adde",
	"./dreams/抱歉.jpg": "1a6f",
	"./fairy-tales/f_b1_moonheel.jpg": "8cdb",
	"./fairy-tales/f_b2_stardusttiara.jpg": "a057",
	"./fairy-tales/f_b3_rosecrescent.jpg": "b395",
	"./fairy-tales/f_g1_starhairtie.jpg": "89a4",
	"./fairy-tales/f_g2_lacestaff.jpg": "887c",
	"./fairy-tales/f_p1_sakurajk.jpg": "dd64",
	"./fairy-tales/f_p2_sweetdream.jpg": "ed0b",
	"./fairy-tales/f_r1_moongoddess.jpg": "f80e",
	"./fairy-tales/f_r2_nightqueen.jpg": "3f86",
	"./fairy-tales/f_u1_plaidskirt.jpg": "a0b2",
	"./fairy-tales/f_u2_academycoat.jpg": "c8f7",
	"./fairy-tales/f_u3_moonstocking.jpg": "1c3e",
	"./fairy-tales/凯蒂猫.gif": "65a4",
	"./star-skirt/b1_jidibingfeng.jpg": "5060",
	"./star-skirt/b2_hanshuangAKM.jpg": "6db0",
	"./star-skirt/b3_bingchuanzhixi.jpg": "bead",
	"./star-skirt/b4_bingjinghuankui.jpg": "a3b1",
	"./star-skirt/b5_lanyuezhiyi.jpg": "db39",
	"./star-skirt/b6_lanjingxunhang.jpg": "d878",
	"./star-skirt/g1_conglinmimi.jpg": "327e",
	"./star-skirt/g2_senlinS686.jpg": "cd81",
	"./star-skirt/g3_lvyexianzong.jpg": "7994",
	"./star-skirt/g4_caobianweizhuangkui.jpg": "198d",
	"./star-skirt/g5_linjianqingfeng.jpg": "7608",
	"./star-skirt/g6_micaiwuxue.jpg": "89b4",
	"./star-skirt/p1_tianxinxiaoemo.jpg": "26bd",
	"./star-skirt/p2_menghuanpaopao.jpg": "bb4d",
	"./star-skirt/p3_mitaowuyu.jpg": "5fc3",
	"./star-skirt/p4_fenjingdiemeng.jpg": "c2ed",
	"./star-skirt/p5_caihongyunduo.jpg": "3ad4",
	"./star-skirt/r1_jixingzhanjia.jpg": "b206",
	"./star-skirt/r2_longhunbarete.jpg": "985c",
	"./star-skirt/r3_cangqiongzhiyi.jpg": "e2e1",
	"./star-skirt/r4_xinghuishengguan.jpg": "6449",
	"./star-skirt/r5_chiyanfenghuang.jpg": "be38",
	"./star-skirt/u1_ziluolanmeiying.jpg": "cf7a",
	"./star-skirt/u2_zijingM416.jpg": "eae2",
	"./star-skirt/u3_miwuzidie.jpg": "8495",
	"./star-skirt/u4_shenmiziguan.jpg": "043a",
	"./star-skirt/u5_musexingchen.jpg": "7797",
	"./star-skirt/u6_anziwuxue.jpg": "159d",
	"./star-skirt/星裙币.png": "48fe",
	"./star-skirt/洛丽碎片.png": "8003",
	"./star-skirt/洛丽碎片1.png": "c975"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5881";